import AddCreditCard from "@/app/profile/add-credit-card";
import { Dialog, DialogContent } from "@/components/ui";

export const AddCreditCardScreenModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="h-full gap-0 overflow-scroll bg-white p-4 md:max-h-[91%]">
        <AddCreditCard />
      </DialogContent>
    </Dialog>
  );
};
